import { AppState } from '@/state.js'

const AppStateMixin = {
  data () {
    return { appState: AppState.instance, AppState }
  }
}

export default AppStateMixin
